var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSouthNode = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 13.5C6 17.0899 8.91015 20 12.5 20C16.0899 20 19 17.0899 19 13.5V11.9646C20.6961 11.7219 22 10.2632 22 8.5C22 6.567 20.433 5 18.5 5C16.567 5 15 6.567 15 8.5C15 9.8962 15.8175 11.1015 17 11.6632V13.5C17 15.9853 14.9853 18 12.5 18C10.0147 18 8 15.9853 8 13.5V11.6632C9.18247 11.1015 10 9.8962 10 8.5C10 6.567 8.433 5 6.5 5C4.567 5 3 6.567 3 8.5C3 10.2632 4.30385 11.7219 6 11.9646V13.5ZM6.5 7C7.32843 7 8 7.67157 8 8.5C8 9.32843 7.32843 10 6.5 10C5.67157 10 5 9.32843 5 8.5C5 7.67157 5.67157 7 6.5 7ZM20 8.5C20 7.67157 19.3284 7 18.5 7C17.6716 7 17 7.67157 17 8.5C17 9.32843 17.6716 10 18.5 10C19.3284 10 20 9.32843 20 8.5Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSouthNode);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/south-node.fec56a368f38dbb7da244e42758989fe.svg";